import { render, staticRenderFns } from "./draft-34.vue?vue&type=template&id=ff518b0e&scoped=true"
import script from "./draft-34.vue?vue&type=script&lang=js"
export * from "./draft-34.vue?vue&type=script&lang=js"
import style0 from "./draft-34.vue?vue&type=style&index=0&id=ff518b0e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff518b0e",
  null
  
)

export default component.exports